import styled from 'styled-components';
import {
  Form,
} from 'antd';

export const FormContainer = styled(Form)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const BaseFormItem = styled(Form.Item)`
  margin: 0;
  width: 100%;
  padding-bottom: 1.5rem;

  & .ant-col,
  & .ant-form-item-control {
    width: 100%;
    max-width: 376px;
  }
`;

export const RemoteSelectContent = styled.div`
  position: relative;
`;

export const RemoteSelectSpinnerContainer = styled.div`
  width: 100%;
  height: 100%;
  background-color: transparent;
  position: absolute;
  top: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const InlineFormGroup = styled(Form.Item)`
  margin: 0;
  width: 100%;
  padding-bottom: 1.5rem;

  & .ant-col,
  & .ant-form-item-control {
    width: 100%;

    &-input-content {
      display: flex;

      & ${BaseFormItem.toString()} {
        padding-bottom: 0;
        max-width: 376px;

        &:first-child {
          margin-right: 1.5rem;
        }
      }
    }
  }
`;

export const SeedsInline = styled(InlineFormGroup)`
  & .seed-consumption-input {
    max-width: 128px;
    width: auto;
  }
`;

export const NotesInline = styled(BaseFormItem)`
  & .ant-col,
  & .ant-form-item-control {
    width: 100%;
    max-width: 100%;
  }
`;
